import { useTranslation } from "react-i18next";
import { useState } from "react";

export default function ConceptSection() {
  const { t } = useTranslation();
  const [showKidsModal, setShowKidsModal] = useState(false);
  const [showYouthModal, setShowYouthModal] = useState(false);
  const [showJapaneseModal, setShowJapaneseModal] = useState(false);
  const [showEnglishModal, setShowEnglishModal] = useState(false);

  return (
    <section id="concept" className="py-24 bg-gradient-to-b from-teal-50 to-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl sm:text-5xl font-bold text-center text-gray-900 mb-16">
          {t("concept_title")}
        </h2>
        
        <div className="space-y-8 mb-16">
          <p className="text-xl text-gray-700 leading-relaxed text-justify">
            {t("concept_text1")}
          </p>
          <p className="text-xl text-gray-700 leading-relaxed text-justify">
            {t("concept_text2")}
          </p>
          <p className="text-2xl font-semibold text-teal-600 leading-relaxed text-center">
            {t("concept_text3")}
          </p>
        </div>

        {/* Why J-Motion Academy */}
        <div className="bg-white rounded-2xl shadow-lg p-8 sm:p-12 mb-12">
          <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">
            {t("why_jmotion_title")}
          </h3>
          
          <div className="space-y-8">
            <div>
              <h4 className="text-2xl font-bold text-teal-600 mb-4">{t("founder_title")}</h4>
              <p className="text-gray-700 leading-relaxed mb-3 text-justify">{t("founder_text1")}</p>
              <p className="text-gray-700 leading-relaxed text-justify">{t("founder_text2")}</p>
            </div>
            
            <div>
              <h4 className="text-2xl font-bold text-teal-600 mb-4">{t("method_title")}</h4>
              <p className="text-gray-700 leading-relaxed mb-3 text-justify">{t("method_text1")}</p>
              <p className="text-gray-700 leading-relaxed text-justify">{t("method_text2")}</p>
            </div>
          </div>
        </div>

        {/* J-Motion Academy Programs */}
        <div className="bg-gradient-to-br from-teal-100 to-orange-50 rounded-2xl shadow-lg p-8 sm:p-12">
          <h3 className="text-3xl font-bold text-gray-900 mb-6 text-center">
            {t("academy_programs_title")}
          </h3>
          <p className="text-lg text-gray-700 mb-8 text-center text-justify">
            {t("academy_intro")}
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <button
              onClick={() => setShowKidsModal(true)}
              className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 border-2 border-teal-200 hover:border-teal-400 text-left cursor-pointer"
            >
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-bear-smile-line text-2xl text-teal-600"></i>
                </div>
                <div className="flex-1">
                  <h4 className="text-xl font-bold text-gray-900 mb-2">{t("academy_kids")}</h4>
                  <p className="text-sm text-teal-600 font-medium">クリックして詳細を見る →</p>
                </div>
              </div>
            </button>

            <button
              onClick={() => setShowYouthModal(true)}
              className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 border-2 border-orange-200 hover:border-orange-400 text-left cursor-pointer"
            >
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-user-star-line text-2xl text-orange-600"></i>
                </div>
                <div className="flex-1">
                  <h4 className="text-xl font-bold text-gray-900 mb-2">{t("academy_youth")}</h4>
                  <p className="text-sm text-orange-600 font-medium">クリックして詳細を見る →</p>
                </div>
              </div>
            </button>

            <button
              onClick={() => setShowJapaneseModal(true)}
              className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 border-2 border-pink-200 hover:border-pink-400 text-left cursor-pointer"
            >
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-graduation-cap-line text-2xl text-pink-600"></i>
                </div>
                <div className="flex-1">
                  <h4 className="text-xl font-bold text-gray-900 mb-2">{t("academy_japanese")}</h4>
                  <p className="text-sm text-pink-600 font-medium">クリックして詳細を見る →</p>
                </div>
              </div>
            </button>

            <button
              onClick={() => setShowEnglishModal(true)}
              className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 border-2 border-blue-200 hover:border-blue-400 text-left cursor-pointer"
            >
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-global-line text-2xl text-blue-600"></i>
                </div>
                <div className="flex-1">
                  <h4 className="text-xl font-bold text-gray-900 mb-2">{t("academy_english")}</h4>
                  <p className="text-sm text-blue-600 font-medium">クリックして詳細を見る →</p>
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>

      {/* Modals */}
      {showKidsModal && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={() => setShowKidsModal(false)}>
          <div className="bg-white rounded-2xl p-8 max-w-2xl w-full max-h-[80vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-start mb-6">
              <h3 className="text-2xl font-bold text-teal-600">J-Motion Kids (3-12歳)</h3>
              <button onClick={() => setShowKidsModal(false)} className="text-gray-500 hover:text-gray-700 cursor-pointer">
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>
            <div className="space-y-4 text-gray-700 text-justify">
              <p className="leading-relaxed">3歳から12歳のお子様を対象とした、動きながら学ぶ言語プログラムです。遊び、アクション、コミュニケーションを通して、日本語や英語を自然に身につけます。</p>
              <p className="leading-relaxed">机に座って暗記するのではなく、体を動かしながら五感をフル活用して学ぶため、楽しみながら自然に言語が定着します。</p>
              <p className="leading-relaxed font-semibold">対象：初めて日本語/英語を学ぶお子様から、すでに学習経験のあるお子様まで</p>
            </div>
          </div>
        </div>
      )}

      {showYouthModal && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={() => setShowYouthModal(false)}>
          <div className="bg-white rounded-2xl p-8 max-w-2xl w-full max-h-[80vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-start mb-6">
              <h3 className="text-2xl font-bold text-orange-600">J-Motion Youth (13-18歳)</h3>
              <button onClick={() => setShowYouthModal(false)} className="text-gray-500 hover:text-gray-700 cursor-pointer">
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>
            <div className="space-y-4 text-gray-700 text-justify">
              <p className="leading-relaxed">13歳から18歳のティーンエイジャーを対象とした、より実践的な言語プログラムです。日常会話だけでなく、学業やキャリアに役立つコミュニケーション力を養います。</p>
              <p className="leading-relaxed">体を動かしながら学ぶJ-Motionメソッドを基盤に、ディスカッション、プレゼンテーション、ロールプレイなど、より高度なアクティビティを取り入れています。</p>
              <p className="leading-relaxed font-semibold">対象：日本語/英語を実践的に使いこなしたい中高生</p>
            </div>
          </div>
        </div>
      )}

      {showJapaneseModal && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={() => setShowJapaneseModal(false)}>
          <div className="bg-white rounded-2xl p-8 max-w-2xl w-full max-h-[80vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-start mb-6">
              <h3 className="text-2xl font-bold text-pink-600">J-Motion Japanese (大人向け)</h3>
              <button onClick={() => setShowJapaneseModal(false)} className="text-gray-500 hover:text-gray-700 cursor-pointer">
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>
            <div className="space-y-4 text-gray-700 text-justify">
              <p className="leading-relaxed">大人の方を対象とした日本語プログラムです。ビジネスシーンや日常生活で使える実践的な日本語を、体験型のアクティビティを通して学びます。</p>
              <p className="leading-relaxed">従来の座学スタイルではなく、動きながら学ぶことで、より自然に日本語が身につき、記憶に定着しやすくなります。</p>
              <p className="leading-relaxed font-semibold">対象：日本語を学びたい大人の方（初心者から上級者まで）</p>
            </div>
          </div>
        </div>
      )}

      {showEnglishModal && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={() => setShowEnglishModal(false)}>
          <div className="bg-white rounded-2xl p-8 max-w-2xl w-full max-h-[80vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-start mb-6">
              <h3 className="text-2xl font-bold text-blue-600">J-Motion English (全年齢対象)</h3>
              <button onClick={() => setShowEnglishModal(false)} className="text-gray-500 hover:text-gray-700 cursor-pointer">
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>
            <div className="space-y-4 text-gray-700 text-justify">
              <p className="leading-relaxed">日本語で英語を学びたい方を対象としたプログラムです。子供から大人まで、それぞれのレベルに合わせた指導を行います。</p>
              <p className="leading-relaxed">J-Motionメソッドを活用し、体を動かしながら英語を学ぶことで、楽しみながら自然に英語が身につきます。日本語でのサポートがあるため、初心者の方も安心して学べます。</p>
              <p className="leading-relaxed font-semibold">対象：日本語で英語を学びたい子供・大人（全レベル対応）</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
